module.exports = __webpack_public_path__ + "static/media/CM.e85b905e.png";